import {Api} from '../../../Api.js'

const RESOURCE = 'taxtype'

export default {
    resource: RESOURCE,
    all(query) {
        return Api().get(this.resource + '/all' )
    },
    query(query) {
        return Api().get(this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.resource + '/' + id)
    },
    create(data) {
        return Api().post(this.resource, data)
    },
    update(id, data) {
        return Api().put(this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.resource + '/' + id)
    }
}


// WEBPACK FOOTER //
// ./src/modules/config/taxtype/TaxTypeService.js